import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import parse from 'html-react-parser';
import { useHistory } from "react-router-dom";
import OMEGA from '../../../omega';
import { EventService } from '../../../models/event-service';
import { SubscriptionService } from '../../../models/subscription-service';
import moment from 'moment';
import { ConfigContext } from "../../../App";
import { URLS } from '../../../constants';
import AIFeedback from '../../aifeedback/aifeedback';

class ActionProvider {
  
  constructor(createChatBotMessage, setStateFunc, createCustomMessage, stateRef) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
    this.createCustomMessage = createCustomMessage;
    this.stateRef = stateRef;
    this.conversationId = null; // Store conversation_id as class property
    this._conversationIdBackup = null; // Backup storage for conversation ID
    this.subscriptionService = SubscriptionService.init(); // Initialize subscription service
  }

  // Getter method to ensure conversation ID is always accessible
  getConversationId = () => {
    // SessionStorage is the most reliable source across component instances
    return sessionStorage.getItem('aiConversationId') || '';
  };

  // Method to set conversation ID - use sessionStorage for reliability
  setConversationId = (id) => {
    // Store in sessionStorage as it persists across component instances
    sessionStorage.setItem('aiConversationId', id);
  };

  // Session ID persists across all messages in one browser-tab session,
  // allowing the backend to maintain conversation context in Redis.
  getSessionId = () => {
    return sessionStorage.getItem('aiSessionId') || '';
  };

  setSessionId = (id) => {
    sessionStorage.setItem('aiSessionId', id);
  };


  SSE_DATA_PREFIX = 'data: ';
  
  // Helper method to get user info from IMS profile
  getUserInfo = () => {
    const imsProfile = sessionStorage.getItem('adobeid_ims_profile');
    let userid = '';
    let email = '';
    
    if (imsProfile) {
        const profile = JSON.parse(imsProfile);
        userid = profile.userId || '';
        email = profile.email || '';
    }
    
    return { userid, email };
  };

  // Helper method to fetch user subscriptions
  getUserSubscriptions = async () => {
    try {
      // Check if user is signed in
      if (!window.adobeIMS?.isSignedInUser()) {
        return { 
          eventSubscriptions: [], 
          productSubscriptions: [],
          slackNotificationEnabled: false,
          teamsNotificationEnabled: false
        };
      }

      // Fetch both event and product subscriptions
      const [eventSubs, productSubs] = await Promise.all([
        this.subscriptionService.getSubscriptions("event", false).catch(() => ({ data: [] })),
        this.subscriptionService.getSubscriptions("product", false).catch(() => ({ data: {} }))
      ]);

      // Extract notification flags from product subscription data
      const productData = productSubs.data || {};
      const slackNotificationEnabled = productData.slackNotificationEnabled || false;
      const teamsNotificationEnabled = productData.teamsNotificationEnabled || false;

      return {
        eventSubscriptions: eventSubs.data || [],
        productSubscriptions: productData,
        slackNotificationEnabled,
        teamsNotificationEnabled
      };
    } catch (error) {
      console.error('Error fetching user subscriptions:', error);
      this.omega_capture(
        `Error fetching user subscriptions: ${error.message || error.toString()}`,
        "Personal Assistant",
        "error"
      );
      return { 
        eventSubscriptions: [], 
        productSubscriptions: {},
        slackNotificationEnabled: false,
        teamsNotificationEnabled: false
      };
    }
  };

  // Browser detection utility
  isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };

  // Centralized error handling
  handleError = (error) => {
    console.log(error);
    
    // Track error to Omega
    this.omega_capture(
      `Chatbot error: ${error?.message || error?.toString() || 'Unknown error'}`,
      "Personal Assistant",
      "error"
    );
    
    // Remove any loading message
    this.removeLastMessage();
    
    // Show generic error message
    const errorMessage = this.createChatBotMessage(
      parse(`I'm sorry, I encountered an error while processing your request. Please try again or select from the available options.`),
      {
        widget: "options",
      }
    );
    this.addMessageToState(errorMessage);
  };



  locales = useContext(ConfigContext).appConfig.languageData;
  eventDefaultValue = {
    element: "Personal Assistant",
    type: "Button",
    action: "click",
    widget: {
      name: "Personal Assistant",
      type: "button"
    },
    feature: "Personal Assistant Usage"
  }

  omega_capture = async (element, widget_name, widget_type) => {
    const omega = OMEGA.init();
    
    // Use the new async method for better reliability
    try {
      await omega.updateAndTrackAsync("event", [{
        ...this.eventDefaultValue,
        element: element,
        widget: {
          name: widget_name,
          type: widget_type
        },
      }]);
    } catch (error) {
      console.warn('Chatbot: Failed to track OMEGA event:', error);
    }
  }


  closeChatbot = async () => {
    const elements = document.getElementsByClassName('chatbot-button');
    if (elements.length > 0) {
        elements[0].click(); 
    }
    this.omega_capture("Close Chatbot", "Personal Assistant", "Button");

  };
  
 
resetState = ()=>{

this.setState((state) => ({
      ...state,
      intentmap: false,
    }));
this.setState((state) => ({
      ...state,
      messagecustom: "",
    }));
this.setState((state) => ({
      ...state,
      productSupport: false,
    }));
this.setState((state) => ({
      ...state,
      supportredirect: false,
    }));
}

handleFindEvents = ()=>{
  this.setState((state) => ({
      ...state,
      findEventId: false,
      ongoingEvents: [],
      findOngoingCSOs: false,
      findOngoingCMRs: false,
      findhistoricCSOs: false,
      findhistoricCMRs: false,
      findLast7DaysEvents: false,
      findLast40DaysEvents: false,
      enableShowEvents: false,
    }));
  this.omega_capture("Find Events", "Personal Assistant", "Button");
const message = this.createChatBotMessage(parse(`Please select an option from below`),{
      widget: "eventoptions",
    });
    this.addMessageToState(message);
}
handleFeedbackSubmit = ()=>{
const message = this.createChatBotMessage(parse(`Your feedback has been recorded.<br/>Thank you.`));
    this.addMessageToState(message);
}

handleFeedbackFailure = ()=>{
const message = this.createChatBotMessage(parse(`Your feedback could not be recorded. Please try again.`));
    this.addMessageToState(message);
}

handleOptions = ()=>{
  this.setState((state) => ({
      ...state,
      findEventId: false,
      ongoingEvents: [],
      findOngoingCSOs: false,
      findOngoingCMRs: false,
      findhistoricCSOs: false,
      findhistoricCMRs: false,
      findLast7DaysEvents: false,
      findLast40DaysEvents: false,
      enableShowEvents: false,
    }));
  this.omega_capture("Launch ChatBot", "Personal Assistant", "Button");

const message = this.createChatBotMessage(parse(`Please select an option from below`),{
      widget: "options",
    });
    this.addMessageToState(message);
}
handleCloseSubscriptions = ()=>{
  this.omega_capture("Close Subscriptions", "Personal Assistant", "Button");
  const message = this.createChatBotMessage(parse(`Redirecting you to the subscriptions page, closing the assistant.`));
  this.addMessageToState(message);
  setTimeout(()=>this.closeChatbot(), 2000);
}

handleCloseBot = async () => {
  this.omega_capture("Close Chatbot", "Personal Assistant", "Button");
  const message = this.createChatBotMessage(parse(`Goodbye! Closing the chatbot.`));
  this.addMessageToState(message);
  this.closeChatbot();
}

handleMoreHelp = ()=>{
  this.omega_capture("More Help", "Personal Assistant", "Button");
const message = this.createChatBotMessage(parse(`Please select the category that you are looking for`),{
      widget: "helpoptions",
    });
    this.addMessageToState(message);
}
handleNotifications = ()=>{
  this.omega_capture("Notifications", "Personal Assistant", "Button");
 this.setState((state) => ({
        ...state,
        notiisuse: true,
      }));
const message = this.createChatBotMessage(parse(`Please select an option from below`),{
      widget: "notioptions",
    });
    this.addMessageToState(message);
}

displaySubscriptions = (type)=>{
 if(type==="Notification"){
this.setState((state) => ({
        ...state,
        notiisuse: true,
      }));
  }else{
this.setState((state) => ({
        ...state,
        notiisuse: false,
      }));
  }
  this.omega_capture("Display Subscriptions", "Personal Assistant", "Button");
const message = this.createChatBotMessage(parse(`Please check your current subscriptions.`),{
      widget: "inbotsub",
    });
    this.addMessageToState(message);
}

SubscriptionComplete = async()=>{
  this.omega_capture("Subscription Complete", "Personal Assistant", "Button");
const message = this.createChatBotMessage(parse(`Thank You.`),{
  widget: "closeoptions",
});
    this.addMessageToState(message);
    // this.showFeedback();
}

showFeedback = (conversationIdOrEvent = '')=>{
this.omega_capture("Feedback Form", "Personal Assistant", "form");

let conversationId = '';
let isFromAIAssistant = false;

if (typeof conversationIdOrEvent === 'string' && conversationIdOrEvent !== '') {
  conversationId = conversationIdOrEvent;
  isFromAIAssistant = true;
} else {
  isFromAIAssistant = false;
}

const payload = {};
if (isFromAIAssistant) {
  payload.conversationId = conversationId;
}


// Pass the payload through the feedback message
// if(!sessionStorage.getItem(('feedback')) || (sessionStorage.getItem(('feedback')) === "false" && parseInt(sessionStorage.getItem('feedbackCount')) < 3)){
const feedbackMessage = {
  type: 'feedback',
  payload: payload
};

    this.addMessageToState(feedbackMessage);

}

findEventId = async()=>{
  this.omega_capture("Find Event Id", "Personal Assistant", "Button");
this.resetState();
  this.setState((state) => ({
        ...state,findEventId:true
}));
 const loadingMessage = this.createChatBotMessage(parse(`loading...`));
  this.addMessageToState(loadingMessage);
await this.getEventInfo("findEvent");
 const message = this.createChatBotMessage(parse(`Please enter the event you are interested in.`),{
          widget: "eventdropdown",
 });
 this.removeLastMessage();
 this.addMessageToState(message);
}
findOngoingCSOs = async ()=>{
  this.omega_capture("Find Ongoing CSOs", "Personal Assistant", "Button");
this.resetState();
  this.setState((state) => ({
        ...state,
        findOngoingCSOs: true,
      }));
  const loadingMessage = this.createChatBotMessage(parse(`loading...`));
  this.addMessageToState(loadingMessage);
  var eventlength = await this.getEventInfo("onGoingCSOs");
  if(eventlength>0){
    const message = this.createChatBotMessage(parse(`Do you want to filter the results by Product or Region ?`),{
          widget: "filterconfirmation",
        });
    this.removeLastMessage();
    this.addMessageToState(message);
  }else{
    this.removeLastMessage();
    this.handleFilter();
  }
}

findOngoingCMRs = async()=>{
  this.omega_capture("Find Ongoing CMRs", "Personal Assistant", "Button");
this.resetState();
  this.setState((state) => ({
        ...state,
        findOngoingCMRs: true,
      }));
    const loadingMessage = this.createChatBotMessage(parse(`loading...`));
  this.addMessageToState(loadingMessage);
   var eventlength = await this.getEventInfo("onGoingCMRs");
    if(eventlength>0){
      const message = this.createChatBotMessage(parse(`Do you want to filter the results by Product or Region ?`),{
            widget: "filterconfirmation",
          });
        this.removeLastMessage();
      this.addMessageToState(message);
    }else{
       this.removeLastMessage();
      this.handleFilter();
    }
}

getEventInfo = (type)=>{
const eventService= EventService.init();
eventService.setLocales(this.locales);
const [servicePromise] = [eventService.fetch()];
    return Promise.all([servicePromise])
      .then(() => {
                let ongoingEvents = eventService.getOnGoingEventsByType();
               
                let ongoingCSOs = ongoingEvents.filter((event)=>!event.type.includes("maintenance"));
                let ongoingCMRs = ongoingEvents.filter((event)=>event.type.includes("maintenance"));
                let allOngoingCSOs = [];
                ongoingCSOs.forEach((cso)=>{cso.list.forEach((csoEvent)=>{allOngoingCSOs.push(csoEvent)})});
                let allOngoingCMRs = [];
                ongoingCMRs.forEach((cmr)=>{cmr.list.forEach((cmrEvent)=>{allOngoingCMRs.push(cmrEvent)})});
                let allOngoingEvents = [];
                ongoingEvents.forEach((event)=>{allOngoingEvents.push(event)});
                 
                const currentDate = new Date();
                const pastDate = new Date();

          
                pastDate.setDate(currentDate.getDate() - 7);
                const pastDateStr = moment(pastDate).format("YYYY-MM-DD");
                const currentDateStr = moment(currentDate).format("YYYY-MM-DD");
                let filterObj = {
                    "products": "",
                    "offerings": [],
                    "regions": [],
                    "environments": [],
                    "date": [
                        pastDateStr,
                        currentDateStr
                    ]
                }
                const FortypastDate = new Date();
                FortypastDate.setDate(currentDate.getDate() - 40);
                const FortypastDateStr = moment(FortypastDate).format("YYYY-MM-DD");
                let FortyDayFilterObj = {
                    "products": "",
                    "offerings": [],
                    "regions": [],
                    "environments": [],
                    "date": [
                        FortypastDateStr,
                        currentDateStr
                    ]
                }
                let statusObj = {
                    "value": "all",
                    "label": "All Status"
                }
                let allhistoricCMRs = [], allhistoricCSOs = [], FortyDayEvents = [], allHistoricEvents = [];
                let historicEventDates = eventService.getIncidentsByDate(filterObj, "all","all",statusObj,undefined,undefined,true)
                historicEventDates.forEach((eventDate)=>{
                        eventDate.incidents.forEach((event)=>{
                            allHistoricEvents.push(event);
                            if(event.eventType.includes("maintenance")){
                                allhistoricCMRs.push(event);
                            }else{
                                allhistoricCSOs.push(event);}

                            })
                });


              let FortyDayhistoricEventDates = eventService.getIncidentsByDate(FortyDayFilterObj, "all","all",statusObj,undefined,undefined,true)
                FortyDayhistoricEventDates.forEach((eventDate)=>{
                        eventDate.incidents.forEach((event)=>{
                          
                                FortyDayEvents.push(event);
                  
                        }

                            )
                });
            if(type==="findEvent"){ this.setState((state) => ({ ...state, ongoingEvents:FortyDayEvents}));}
      if(type==="onGoingCSOs"){return allOngoingCSOs.length;}
      else if(type === "onGoingCMRs"){return allOngoingCMRs.length;}
      else if(type === "historicCMRs"){return allhistoricCMRs.length;}
      else if(type === "historicCSOs"){return allhistoricCSOs.length;}
      else if(type === "last7DaysEvents"){return allHistoricEvents.length;}
      else if(type === "last40DaysEvents"){return FortyDayEvents.length;}
      
                
  })
  .catch((error) => {
      console.error('Error in chatbot getEventInfo:', error);
      this.omega_capture(
          `Error fetching event info in chatbot (${type}): ${error.message || error.toString()}`,
          "Personal Assistant",
          "error"
      );
      // Call handleError to show user-friendly message
      this.handleError(error);
      // Return 0 to indicate no events found
      return 0;
  });

}

findLast7DaysCSOs = async()=>{
  this.omega_capture("Find Last 7 Days CSOs", "Personal Assistant", "Button");
this.resetState();
  this.setState((state) => ({
        ...state,
        findhistoricCSOs: true,
      }));
  const loadingMessage = this.createChatBotMessage(parse(`loading...`));
  this.addMessageToState(loadingMessage);
   var eventlength = await this.getEventInfo("historicCSOs");
    if(eventlength>0){
      const message = this.createChatBotMessage(parse(`Do you want to filter the results by Product or Region ?`),{
            widget: "filterconfirmation",
          });
        this.removeLastMessage();
      this.addMessageToState(message);
    }else{
       this.removeLastMessage();
      this.handleFilter();
    }
}


findLast7DaysEvents = async()=>{
  this.omega_capture("Find Last 7 Days Events", "Personal Assistant", "Button");
this.resetState();
  this.setState((state) => ({
        ...state,
        findLast7DaysEvents: true,
      }));
  const loadingMessage = this.createChatBotMessage(parse(`loading...`));
  this.addMessageToState(loadingMessage);
   var eventlength = await this.getEventInfo("last7DaysEvents");
    if(eventlength>0){
      const message = this.createChatBotMessage(parse(`Do you want to filter the results by Product or Region ?`),{
            widget: "filterconfirmation",
          });
        this.removeLastMessage();
      this.addMessageToState(message);
    }else{
       this.removeLastMessage();
      this.handleFilter();
    }
}

findLast40DaysEvents = async()=>{
  this.omega_capture("Find Last 40 Days Events", "Personal Assistant", "Button");
this.resetState();
  this.setState((state) => ({
        ...state,
        findLast40DaysEvents: true,
      }));
  const loadingMessage = this.createChatBotMessage(parse(`loading...`));
  this.addMessageToState(loadingMessage);
   var eventlength = await this.getEventInfo("last40DaysEvents");
    if(eventlength>0){
      const message = this.createChatBotMessage(parse(`Do you want to filter the results by Product or Region ?`),{
            widget: "filterconfirmation",
          });
        this.removeLastMessage();
      this.addMessageToState(message);
    }else{
       this.removeLastMessage();
      this.handleFilter();
    }
}



findLast7DaysCMRs = async()=>{
  this.omega_capture("Find Last 7 Days CMRs", "Personal Assistant", "Button");
this.resetState();
  this.setState((state) => ({
        ...state,
        findhistoricCMRs: true,
      }));
  const loadingMessage = this.createChatBotMessage(parse(`loading...`));
  this.addMessageToState(loadingMessage);
  var eventlength = await this.getEventInfo("historicCMRs");

    if(eventlength>0){
      const message = this.createChatBotMessage(parse(`Do you want to filter the results by Product or Region ?`),{
        widget: "filterconfirmation",
      });
        this.removeLastMessage();
      this.addMessageToState(message);
    }else{
       this.removeLastMessage();
      this.handleFilter();
    }
}

showFilter = ()=>{
  this.omega_capture("Show Filter", "Personal Assistant", "Button");
  this.setState((state) => ({
        ...state,
      }));
  const message = this.createChatBotMessage(parse(`Please select a region and product`),{
        widget: "regiondropdown",
      });
  this.addMessageToState(message);
}
sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
handleFilter = async(regionVal,productVal)=>{
  const region= regionVal?regionVal:"All";
  const product= productVal?productVal:"All";
  this.omega_capture("Filter - "+region+" - "+product, "Personal Assistant", "Button");
  this.setState((state) => ({
        ...state,
        regionprop: regionVal,
        myCustomProperty: productVal,
        enableShowEvents: true,
      }));


  const message = this.createChatBotMessage(parse(`Here's the list of Events. Please click on an event for more information.`),{
        widget: "showevents",
      });
  this.addMessageToState(message);
  // this.showFeedback();
}

handleEventFilter = async(eventId)=>{
  this.omega_capture("Event Filter - "+eventId, "Personal Assistant", "Button");
this.setState((state) => ({
        ...state,
        eventprop: eventId,
      
      }));

  // Calculate total number of products across all events
  let totalProducts = 0;
  if (eventId && eventId.length > 0) {
    eventId.forEach((event) => {
      if (event.productInfo && event.productInfo.length) {
        totalProducts += event.productInfo.length;
      }
    });
  }

  // Show specific message if one event affects one product, otherwise show generic message
  const message = this.createChatBotMessage(totalProducts === 1 && eventId.length === 1 ? parse(`Here's the event information. The page has been refreshed to display the complete history of the event.`) : totalProducts > 0 ? parse(`Here's the list of Events. Please click on an event for more information.`) : parse(`No events found. Please try again.`),{
        widget: "showevents",
      });

 this.addMessageToState(message);
}
 

  addMessageToState = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message]
    }));
  };


  handleUserInput = (userMessage) => {
    this.omega_capture("User Input - "+userMessage, "Personal Assistant", "Text Input");
    this.processUserMessage(userMessage);

  };

  processUserMessage = async (userMessage) => {

    await this.handleStreamingResponse(userMessage);
  
  };

  handleStreamingResponse = async (userMessage) => {
    
    try {
      const initialMessage = this.createChatBotMessage("Processing...");
      this.addMessageToState(initialMessage);
      
      // Get user info from IMS profile
      const { userid, email } = this.getUserInfo();
      
      // Get user token for Authorization header
      const userToken = window.adobeIMS?.getAccessToken()?.token || '';
      
      // Fetch user subscriptions and notification flags
      const subscriptionData = await this.getUserSubscriptions();
      
      // Initialize state for streaming
      this.streamingState = {
        accumulatedResponse: '',
        sources: [],
        conversationId: null,
        isComplete: false
      };
      
      // Safari-compatible fetch with explicit headers
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/plain, text/event-stream, */*',
          'Cache-Control': 'no-cache',
          'Connection': 'keep-alive',
          'Authorization': `Bearer ${userToken}`
        },
        body: JSON.stringify({
          question: userMessage,
          internal: true,
          provider: "aws",
          rag_type: "extracter",
          adobe_id: userid,
          session_id: this.getSessionId() || undefined,
          slackNotificationEnabled: subscriptionData.slackNotificationEnabled,
          teamsNotificationEnabled: subscriptionData.teamsNotificationEnabled,
          user_subscriptions: {
            eventSubscriptions: subscriptionData.eventSubscriptions,
            productSubscriptions: subscriptionData.productSubscriptions
          }
        }),
        // Safari-specific options
        credentials: 'omit',  // Changed from 'same-origin' for CORS
        mode: 'cors',
        // Safari streaming options
        keepalive: false,
        redirect: 'follow'
      };

      // Make the streaming request
      const response = await fetch(`${URLS.STREAM_URL}/ask-stream`, requestOptions);


      if (!response.ok) {
        this.handleError(new Error(`HTTP error! status: ${response.status} - ${response.statusText}`));
        return;
      }

      // Check if response body is readable
      if (!response.body) {
        this.handleError(new Error('Response body is not readable'));
        return;
      }
      // Start reading stream data (Safari-compatible Promise approach)
      this.readStreamData(response);

    } catch (error) {
      this.handleError(error);
    }
  };

  readStreamData = async (response) => {
    console.log('📖 Starting to read stream data in browser:', this.isSafari() ? 'Safari' : 'Other');
    
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let lineBuffer = ''; // Buffer to accumulate incomplete lines between chunks

    const readStream = () => {
      reader.read().then(({ done, value }) => {
       
        if (done) {
          // If we reach here without an 'end' signal, finalize anyway
          if (this.streamingState && !this.streamingState.isComplete) {
            this.finalizeStreamedMessage();
          }
          return;
        }

        const chunk = decoder.decode(value);
        
        // Add chunk to line buffer
        lineBuffer += chunk;
        
        // Split by newlines, but keep incomplete line in buffer
        const lines = lineBuffer.split('\n');
        lineBuffer = lines.pop(); // Keep the last (potentially incomplete) line in buffer

        // Process only complete lines (ones that had \n)
        for (const line of lines) {
          if (line.startsWith(this.SSE_DATA_PREFIX)) {
           
            try {
              const jsonData = JSON.parse(line.substring(this.SSE_DATA_PREFIX.length));
              this.handleStreamingData(jsonData);
              
              // Check if stream is complete (but only if streamingState still exists)
              if (this.streamingState && this.streamingState.isComplete) {
               
                return;
              }
            } catch (parseError) {
              this.handleError(parseError, 'readStreamData - JSON parsing');
              return;
            }
          }
        }

        readStream(); // Continue reading
      }).catch(error => {
        // Only show error message if we haven't accumulated any content
        if (!this.streamingState || !this.streamingState.accumulatedResponse || this.streamingState.accumulatedResponse.trim() === '') {
          this.handleError(error, 'readStreamData - stream reading');
        } else {
          // We have content, so finalize what we have
          try {
            this.finalizeStreamedMessage();
          } catch (finalizeError) {
            this.handleError(finalizeError);
          }
        }
      });
    };

    readStream(); // Start reading
  };

  handleStreamingData = (data) => {
    try {
      switch (data.type) {
        case 'sources':
          this.handleSourcesData(data.data);
          break;
          
        case 'response':
          this.handleResponseChunk(data.data);
          break;
        case 'error':
          this.handleErrorData(data.data);
          break;
          
        case 'end':
          this.handleStreamEnd();
          break;
          
        
          
        default:
          console.log('Unknown SSE data type:', data.type, data);
      }
    } catch (error) {
      this.handleError(error);
    }
  };

  handleErrorData = (errorData) => {

    try {
      // Remove the loading message
      this.removeLastMessage();
      
      // Check for specific "Question is not safe to use" error
      if (errorData && errorData.error === "Question is not safe to use") {
        const errorMessage = this.createChatBotMessage(
          parse(`We are unable to process this request. Please try again with a different question or later. You can also select from the available options.`),
          {
            widget: "options",
          }
        );
        this.addMessageToState(errorMessage);
      } else {
        // Handle other error types with generic message
        const errorMessage = this.createChatBotMessage(
          parse(`I'm sorry, I encountered an error while processing your request. Please try again or select from the available options.`),
          {
            widget: "options",
          }
        );
        this.addMessageToState(errorMessage);
      }
      
    } catch (error) {
      this.handleError(error);
    }
  };

  handleSourcesData = (sourceData) => {
    try {
      if (sourceData && sourceData.sources) {
        this.streamingState.sources = sourceData.sources;
        if (sourceData.conversation_id) {
          this.streamingState.conversationId = sourceData.conversation_id;
          this.setConversationId(sourceData.conversation_id);
        }
        if (sourceData.session_id) {
          this.setSessionId(sourceData.session_id);
        }
      }
    } catch (error) {
      this.handleError(error);
    }
  };

  handleResponseChunk = (responseData) => {
    try {
      if (responseData && responseData.chunk) {
        this.streamingState.accumulatedResponse += responseData.chunk;
        this.updateLastMessage(this.streamingState.accumulatedResponse, false);
      }
    } catch (error) {
      this.handleError(error);
    }
  };

  handleStreamEnd = () => {
    try {
      this.streamingState.isComplete = true;
      this.finalizeStreamedMessage();
    } catch (error) {
      this.handleError(error);
    }
  };

  finalizeStreamedMessage = () => {
    try {
      // Ensure we have content to finalize
      if (!this.streamingState || !this.streamingState.accumulatedResponse) {
        console.warn('No accumulated response to finalize');
        return;
      }
      
      // Preserve conversation ID before clearing streaming state
      const conversationId = this.streamingState.conversationId;
      if (conversationId) {
        this.setConversationId(conversationId);
      }
      
      this.updateLastMessage(this.streamingState.accumulatedResponse, false);
      this.addWidgetToLastMessage("aifeedback");
      
      // Clean up streaming state
      this.streamingState = null;
    } catch (error) {
      this.handleError(error);
    }
  };


  removeLastMessage=()=>{
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages.slice(0, -1)]
    }));
  }

  updateLastMessage = (content, includeFeedback = true) => {
    try {
      this.setState((prevState) => {
        const messages = [...prevState.messages];
        if (messages.length > 0) {
          const lastMessage = messages[messages.length - 1];
          if (lastMessage.type !== 'user') {
            // Create the message content with markdown only
            const messageContent = (
              <div>
                <ReactMarkdown 
                  remarkPlugins={[remarkGfm, remarkBreaks]}
                  components={{
                    a: ({ href, children, ...props }) => (
                      <a 
                        href={href} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        {...props}
                      >
                        {children}
                      </a>
                    )
                  }}
                >
                  {content}
                </ReactMarkdown>
              </div>
            );
            
            // Update the bot's message with the new content
            messages[messages.length - 1] = {
              ...lastMessage,
              message: messageContent
            };
          }
        }
        return {
          ...prevState,
          messages: messages
        };
      });
    } catch (error) {
      this.handleError(error);
    }
  };

  addWidgetToLastMessage = (widgetName) => {
    try {
      this.setState((prevState) => {
        const messages = [...prevState.messages];
        if (messages.length > 0) {
          const lastMessage = messages[messages.length - 1];
          if (lastMessage.type !== 'user') {
            // Add widget to the existing message
            messages[messages.length - 1] = {
              ...lastMessage,
              widget: widgetName
            };
          }
        }
        return {
          ...prevState,
          messages: messages
        };
      });
    } catch (error) {
      this.handleError(error);
    }
  };

}

export default ActionProvider;



